
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_nr3gs_1mr3y_5",
  "textarea": "awsui_textarea_nr3gs_1mr3y_9",
  "action-button": "awsui_action-button_nr3gs_1mr3y_13"
};
  